import React, { useEffect } from 'react';
import { Spinner, CollapseBlock } from '../../../../common';
import MenuTable from './MenuTable.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { SortAscendingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  useDeleteMenuItemMutation,
  useGetMenuQuery,
} from '../../../../../redux/services/menu';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';

const MenuPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('Menu') + ' - FRI CMS';
  }, []); // Runs on mount

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();

  const { data: menu, isLoading, refetch } = useGetMenuQuery();
  const [deleteMenuItem, { isSuccess: isDeleteSuccess }] =
    useDeleteMenuItemMutation();

  useEffect(() => {
    if (isDeleteSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Menu')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať položku menu')}
        createUrl={routes.cmsMenuCreate}
        permissionsBasic={'menu'}
        mainActions={[
          {
            onClick: () => navigate(routes.cmsMenuOrder),
            title: t('Zoradiť položky menu'),
            icon: <SortAscendingOutlined />,
          },
        ]}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <MenuTable
            menu={menu}
            onDelete={(record) => deleteMenuItem(record.id)}
            onDetailClick={(record) =>
              navigate(`${routes.cmsMenuEdit}/${record.id}`)
            }
            onCreateClick={() => navigate(`${routes.cmsMenuCreate}`)}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default MenuPage;
